import { useRef, useState } from "react";
import { useLeagues } from "../context/leagues";
import LeagueRow from "./booth/LeagueRow";
import AddLeagueModal from "./addLeagueModal";
import LeagueInfo from "./leagueInfo";
import "../styles/leagueStack.css";

const GET_STARTED_STEPS = [
  {
    label: "Paste your league link",
    description: "From ESPN or Sleeper. We find the league ID for you.",
  },
  {
    label: "Claim your team",
    description: "So your dispatch knows whose side it's on.",
  },
  {
    label: "Invite your league",
    description: "Share one link. Every manager adds their own email.",
  },
];

function LeagueStack() {
  const leagues = useLeagues();
  const [selectedLeagueId, setSelectedLeagueId] = useState(null);
  const [openLeagueInfo, setOpenLeagueInfo] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const addButtonRef = useRef(null);
  const selectedLeague = leagues?.current?.find(
    (l) => l.id === selectedLeagueId,
  );
  const isEmpty = leagues.current && leagues.current.length === 0;

  const handleLeagueInfoOpen = (league) => {
    setSelectedLeagueId(league.id);
    setOpenLeagueInfo(true);
  };

  const handleLeagueInfoClose = () => {
    setOpenLeagueInfo(false);
    setSelectedLeagueId(null);
  };

  const handleAddClose = () => {
    setShowAdd(false);
    addButtonRef.current?.focus();
  };

  const handleAddOpen = () => {
    setShowAdd(true);
  };

  return (
    <>
      <AddLeagueModal open={showAdd} onClose={handleAddClose} />
      {openLeagueInfo && (
        <LeagueInfo
          open={openLeagueInfo}
          league={selectedLeague}
          onClose={handleLeagueInfoClose}
        />
      )}
      <div className="booth-leagues-header">
        <div className="booth-leagues-header-text">
          <h1 className="booth-section-title">Your leagues</h1>
          {!isEmpty && (
            <span className="booth-leagues-header-dek">
              {leagues.current.length} league
              {leagues.current.length === 1 ? "" : "s"}. Dispatches file
              every Tuesday at 5:00 AM.
            </span>
          )}
        </div>
        {!isEmpty && (
          <button
            type="button"
            ref={addButtonRef}
            className="booth-btn booth-btn--primary"
            onClick={handleAddOpen}
          >
            Add league
          </button>
        )}
      </div>
      {isEmpty ? (
        <section
          className="booth-leagues-empty-hero"
          aria-label="Get started"
        >
          <div className="booth-leagues-empty-copy">
            <h2 className="booth-leagues-empty-headline">
              Your league has a story. Let's file it.
            </h2>
            <p className="booth-leagues-empty-dek">
              Add an ESPN or Sleeper league and The Booth writes a dispatch
              for every matchup each Tuesday morning.
            </p>
            <div className="booth-leagues-empty-cta-row">
              <button
                type="button"
                ref={addButtonRef}
                className="booth-btn booth-btn--primary"
                onClick={handleAddOpen}
              >
                Add your first league <span aria-hidden="true">→</span>
              </button>
            </div>
            <span className="booth-leagues-empty-caption">
              Takes about a minute.
            </span>
          </div>
          <div className="booth-leagues-empty-steps">
            {GET_STARTED_STEPS.map((step, index) => (
              <div className="booth-leagues-empty-step" key={step.label}>
                <span className="booth-leagues-empty-step-num">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <span className="booth-leagues-empty-step-label">
                  {step.label}
                </span>
                <span className="booth-leagues-empty-step-desc">
                  {step.description}
                </span>
              </div>
            ))}
          </div>
        </section>
      ) : (
        <div className="booth-leagues-list">
          {leagues.current &&
            leagues.current.map((league) => (
              <LeagueRow
                key={league.id}
                league={league}
                onManage={handleLeagueInfoOpen}
              />
            ))}
        </div>
      )}
    </>
  );
}

export default LeagueStack;
